<template>
  <BreadCrumb PageTitle=" Liste des secteurs" />
    <ListeSecteur />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import ListeSecteur from "@/components/Secteur/ListeSecteur.vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  
    export default defineComponent({
      name: "ListeSecteurPage",
      components: {
        ListeSecteur,
      },
    });
  </script>